module.exports = __webpack_public_path__ + "img/s7Model4.be74cff6.webp";